{
    "name": "@binance/connector-typescript",
    "version": "0.3.16",
    "description": "This is a lightweight library that works as a connector to the Binance public API.",
    "main": "./dist/index.js",
    "module": "./dist/index.mjs",
    "types": "./dist/index.d.ts",
    "scripts": {
        "test": "npx jest --runInBand",
        "build": "tsup",
        "dev": "ts-node ./examples/restful/market.ts",
        "lint": "eslint --config .eslintrc.json --ext ts . --fix"
    },
    "keywords": [
        "Binance",
        "API"
    ],
    "author": "Binance",
    "license": "MIT",
    "files": [
        "dist"
    ],
    "devDependencies": {
        "@types/jest": "^29.5.4",
        "@types/node": "22.9.0",
        "@types/ws": "^8.5.5",
        "@typescript-eslint/eslint-plugin": "7.17.0",
        "@typescript-eslint/parser": "7.17.0",
        "dotenv": "^16.3.1",
        "eslint": "8.57.0",
        "jest": "^29.6.4",
        "ts-jest": "^29.1.1",
        "ts-node": "^10.9.1",
        "tsup": "^7.2.0",
        "typescript": "^5.7.2"
    },
    "dependencies": {
        "axios": "^1.7.4",
        "ws": "^8.17.1"
    }
}
